import { cn } from "@/lib/utils";

/**
 * Small-caps eyebrow label with optional terracotta hairline accent.
 * "Numéro 24 · Printemps 2026" / "Chapitre 01" / "Au menu · S.19"
 */
export function Eyebrow({
  children,
  rule = false,
  ruleRight = false,
  accent = false,
  className,
  as: As = "div",
}: {
  children: React.ReactNode;
  rule?: boolean;
  ruleRight?: boolean;
  accent?: boolean;
  className?: string;
  as?: "div" | "span" | "p";
}) {
  return (
    <As
      className={cn(
        "eyebrow",
        accent && "text-accent",
        className,
      )}
    >
      {rule && <span className="eyebrow-rule" aria-hidden />}
      {children}
      {ruleRight && <span className="eyebrow-rule" aria-hidden />}
    </As>
  );
}
